import { IBlogItem } from "interfaces";
import { SwitchButton } from "components/switchButton";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import moment from "moment";
import { isHaveActionPermission } from "utills/helpers";

interface BlogCardProps {
  data?: IBlogItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const BlogCard = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: BlogCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((item: IBlogItem, index: number) => (
        <div
          key={index}
          className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
        >
          <div className="w-full flex items-center justify-between">
            <SwitchButton
              checked={item.is_active}
              disabled={!isHaveActionPermission("blog", "mkt", "edit")}
              onChange={() => _toggleActive(item.id, item.is_active)}
            />

            <div className="flex items-center gap-x-[8px]">
              <Link to={`/mkt/blog/${item.id}`} className="w-fit">
                <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                  <EyeIcon className="w-4 h-4 text-black" />
                </Button>
              </Link>
              {isHaveActionPermission("blog", "mkt", "edit") ? (
                <Link to={`/mkt/blog/${item.id}/edit`} className="w-fit">
                  <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                    <PencilIcon className="w-4 h-4 text-black" />
                  </Button>
                </Link>
              ) : (
                <></>
              )}
            </div>
          </div>

          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">No</p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Title vie</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.title_vi}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Category eng
            </p>
            <p className="flex-1 text-right text-sm leading-6 capitalize">
              {item.category}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Sub-category eng</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.sub_category_name_en}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Hot position</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.is_hot_position ? "Yes" : "No"}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Publish at</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.publish_at ? moment(item.publish_at).format("DD/MM/YYYY HH:mm:ss") : ""}
            </p>
          </li>
        </div>
      ))}
    </ul>
  );
};
